import styled from 'styled-components';

const ContentWrapper = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: calc(100% - ${ ({ theme }) => theme.size.size_70 });
    padding: ${ ({ theme }) => `${ theme.size.size_70 } ${ theme.size.size_40 } ${ theme.size.size_40 }` };
    width: 100%;

    @media ${ ({ theme }) => theme.breakpoints.mediaQueries.isTablet } {
        padding: ${ ({ theme }) => `${ theme.size.size_70 } ${ theme.size.size_30 } ${ theme.size.size_30 }` };
    }

    @media ${ ({ theme }) => theme.breakpoints.mediaQueries.isMobile } {
      padding: ${ ({ theme }) => `${ theme.size.size_70 } 0 ${ theme.size.size_20 }` };
    }
`;

export default ContentWrapper;
